/**
 * Create application modal on dashboard page
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import generate from 'firebase-auto-ids'
import { Modal, Label } from 'wix-style-react'
import MessageBoxFunctionalLayout from 'wix-style-react/src/MessageBox/MessageBoxFunctionalLayout'
import * as _ from 'lodash'

import { deleteTemporaryIntegrationData } from 'controllers/logic'
import * as integrationType from 'constants/integrationType'
import ShopifyConnect from '../integrations/ShopifyConnect'
import IntegrationsButtons from '../integrations/IntegrationsButtons'
import AppNameInput from 'components/shared/AppNameInput'

const Container = styled.div`
  & > div {
    padding-top: 15px;
  }

  & > div:first-of-type {
    padding-top: 0;
  }
`
const IntegrationContainer = styled.div`
  margin-top: 1em;
`

class CreateAppModal extends Component {

  constructor (props) {
    super(props)

    this.state = {
      appName: '',
      selectedIntegration: null,
      // googleAnalyticsId: '',
      errorMessage: null,
      appId: generate(_.now())
    }
  }

  componentDidMount () {
    this.props.dispatch(deleteTemporaryIntegrationData())
  }

  handleCreateApp = () => {
    const { user } = this.props
    const { appId, appName, selectedIntegration } = this.state
    const integrationParams = _.get(user, ['temporaryIntegrationData', appId], {type: selectedIntegration})
    // console.log('handleCreateApp', selectedIntegration)
    this.props.handleCreateApp(appId, appName, selectedIntegration, integrationParams)
  }

  onChangeAppName = (appName) => {
    this.setState({ appName: appName })
  }

  onGoogleAnalyticsChange = (e) => {
    this.setState({ googleAnalyticsId: e.target.value.replace(/[\W]+/g, '-') })
  }

  onSelectIntegration = (iType) => this.setState({ selectedIntegration: iType })

  renderIntegrationParams () {
    const { user } = this.props
    const { selectedIntegration, appId } = this.state
    switch (selectedIntegration) {
      case integrationType.SHOPIFY:
        return (
          <ShopifyConnect
            appId={appId}
            shopName={_.get(user, ['temporaryIntegrationData', appId, 'shopName'])}
            accessToken={_.get(user, ['temporaryIntegrationData', appId, 'accessToken'])}
          />
        )
      default:
        return null
    }
  }

  renderContent () {
    const { templateId } = this.props
    const { selectedIntegration } = this.state
    return (
      <Container>
        <AppNameInput onChangeAppName={this.onChangeAppName} />
        <IntegrationContainer>
          <Label>Add integration:</Label>
          <IntegrationsButtons
            templateId={templateId}
            selectedIntegration={selectedIntegration}
            onSelectIntegration={this.onSelectIntegration}
          />
        </IntegrationContainer>

        {this.renderIntegrationParams()}

        {/*<TextField>
          <Label>Google Analytics ID:</Label>
          <Input
            placeholder='Enter Google Analytics ID'
            onChange={this.onGoogleAnalyticsChange}
            value={googleAnalyticsId}
            maxLength={20}
          />
        </TextField>*/}
      </Container>
    )
  }

  render () {
    const { handleCancel } = this.props
    return (
      <Modal zIndex={1000000} isOpen contentLabel=''>
        <MessageBoxFunctionalLayout
          theme='blue'
          title='Create app'
          confirmText='Create'
          cancelText='Cancel'
          onOk={this.handleCreateApp}
          onCancel={handleCancel}
          disableConfirmation={this.state.appName === ''}
        >
          {this.renderContent()}
        </MessageBoxFunctionalLayout>
      </Modal>
    )
  }
}

CreateAppModal.propTypes = {
  templateId: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  handleCreateApp: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(CreateAppModal)



// WEBPACK FOOTER //
// ./src/components/dashboard/CreateAppModal.js